module.exports = __webpack_public_path__ + "img/img_32389_0_396.3819581e.png";